<template>
  <div class="projectDetailPage">
    <common-title
      :titleName="protrialDetail.title"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
      @goBack="goBackHeader"
    />
    <div v-if="!isMini" class="empty"></div>
    <template v-if="hasData">
      <div class="video-player" style="position: relative">
        <div id="player"></div>
        <div class="next-video" v-if="videoEndTool">
          <template v-if="lastPaly">
            <span>本节课程已学完</span>
            <div class="tool-btn">
              <div class="replay-btn" @click="replay">重新播放</div>
            </div>
          </template>
          <template v-else>
            <div class="replay-btn">加载中‧‧‧</div>
          </template>
        </div>
      </div>
      <div class="projectHeaderBox">
        <h3>{{ protrialDetail.introduction }}</h3>
        <div class="courseTotalNum">
          共{{ protrialDetail.videoInfos ? protrialDetail.videoInfos.length : 0 }}堂课
        </div>
        <div class="projectVideoList" ref="wrapper">
          <ul class="projectScrollBox" ref="cont">
            <li
              v-for="(item, index) in videoList"
              :key="index"
              @click="handleClick($event, item, index)"
            >
              <div class="centerVideo">
                <img :src="item.cover" @error="imgOnError(index)" />
                <div :class="['infoVideo', { activeVideo: activeId === index }]">
                  <div>{{ index + 1 }}</div>
                  <span v-show="activeId === index">正在播放</span>
                  <p>{{ getVideoMinTime(item.duration) }}</p>
                </div>
              </div>
              <h5 class="ellipsis-2 centerVideoName">{{ item.name }}</h5>
            </li>
          </ul>
        </div>

        <div class="teacherInfo" v-if="protrialDetail.teacherIds">
          <h2 class="subPartTitle">师资介绍</h2>
          <div class="teacherList">
            <van-swipe :autoplay="5000" :show-indicators="false">
              <van-swipe-item v-for="(item, index) in teacherListData" :key="index">
                <div class="teacherItem" @click="teacherDetail(item)">
                  <img :src="item.topicWebHead || defaultImg" />
                  <div class="introduceTeacher">
                    <h5>{{ item.publicName }}</h5>
                    <ul>
                      <li v-for="val in item.teachMainModule" :key="val">{{ val }}</li>
                    </ul>
                    <p class="ellipsis-3">{{ item.teacherBrief }}</p>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div class="courseRecommend" v-if="protrialDetail.productId || protrialDetail.packageId">
          <img
            class="bg"
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/porjectCourse/bg.png"
            alt=""
          />
          <div class="subIntroduce">
            <img
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/porjectCourse/icon.png"
              alt=""
            />
            <span>视频节选自正课内容，想观看完整课程，请点击下方课程前往了解~</span>
          </div>
          <div class="courseBox" @click="goback()">
            <van-swipe :autoplay="5000" :show-indicators="false">
              <van-swipe-item v-for="(item, index) in courseInfoData" :key="index">
                <CombinationCard v-if="item.packageId" :item="item" />
                <HotCourseCard v-if="item.productId" :item="item" />
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div class="projectPart" v-if="porjectList">
          <h2 class="subPartTitle">为您推荐</h2>
          <div class="projectBox">
            <ProjectCard
              v-for="(item, index) in porjectList"
              :key="index"
              :projectInfo="item"
              :useWhere="2"
              :subTitleHide="true"
              @click.native="goPojectDetial(item)"
            />
          </div>
        </div>
      </div>
    </template>
    <EmptyData v-else :emptyName="'noProductList'" />

    <CommonLoading :loading="loading" />
    <Foot />
    <OpenMember ref="member" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import loadJS from 'load-js';
import { RECORD_SITE_ID } from '@/utils/common';
import { reqTeacherList, reqClassNameType } from '@/api/courseDetail';
import CommonTitle from '@/components/header/CommonTitle.vue';
import CommonLoading from '@/components/commonComponents/CommonLoading.vue';
import Foot from '@/components/foot/privacy.vue';
import { resetProductData, resetCoursePackage, setBaseUrl, gioPlatform } from '@/utils/tools';
import ProjectCard from '@/pages/arkHome/components/projectCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import BScroll from 'better-scroll';
import {
  reqProtrialRecommend,
  reqProtrialDetail,
  reqProducts,
  reqProtrialAccumulate,
} from '@/api/home';
import { reqCombinationlist } from '@/api/combination';
import EmptyData from '@/components/emptyData/emptyData.vue';
import OpenMember from '@/pages/arkHome/components/openMember.vue';
import HotCourseCard from '../../components/hotCourseCard/hotCourseCard.vue';
import defaultImg from '../../assets/img/arkHome/live-tea-bg.png';

export default {
  components: {
    CommonTitle,
    CommonLoading,
    Foot,
    ProjectCard,
    CombinationCard,
    HotCourseCard,
    EmptyData,
    OpenMember,
  },
  data() {
    return {
      defaultImg,
      idx: 0,
      videoList: [],
      videoEndTool: false,
      player: null,
      loading: false,
      playerType: 'CC', // 播放器类别  CC BJY
      scrollloca: '',
      porjectList: [], // 推荐精品课列表
      projectId: this.$route.query.projectId,
      protrialDetail: [],
      courseInfoData: [], // 推荐课程
      teacherListData: [], // 师资信息
      activeId: 0,
      lastPaly: false, // 是否最后一个
      hasData: true, // 是否有课程信息
      isMini: this.$root.whatEev == 'miniprogram',
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    scrollloca() {
      // 跳转到对应数字的div区域
      this.scroll.scrollToElement(this.scrollloca);
    },
    $route: {
      handler() {
        this.$router.go();
        this.scrollInit();
      },
      deep: true,
    },
  },

  methods: {
    goBackHeader() {
      this.$toast.clear();
      this.$router.push({
        path: '/home',
        query: {
          code: 8,
        },
      });
    },
    // 图片加载失败
    imgOnError(index) {
      this.videoList[index].cover =
        'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/porjectCourse/fm.png';
    },
    handleClick(e, data, index) {
      if (this.activeId === index) return;
      // this.scrollloca = e.target;
      this.activeId = index;
      this.idx = index;
      this.player.changeVideo(data.vid, {});
      this.lastPaly = index === this.videoList.length;
      this.gioEvent(data);
    },
    goback() {
      sessionStorage.setItem('back', true);
    },
    // 获取精品课程详情
    async getProtrialDetail() {
      const res = await reqProtrialDetail(this.projectId);
      if (res?.code === 0) {
        if (!res?.data) {
          this.hasData = false;
          return;
        }
        this.hasData = true;
        this.protrialDetail = res?.data;
        this.init();

        this.getCourseCardInfo();
        this.getTeacherList();
        this.getProtrialRecommend();
        this.$nextTick(() => {
          const timer = setTimeout(() => {
            // 其实我也不想写这个定时器的，这相当于又嵌套了一层$nextTick，但是不这么写会失败
            if (timer) {
              clearTimeout(timer);
              this.verScroll();
            }
          }, 200);
        });
        // GIO转化变量
        // eslint-disable-next-line no-undef
        gio('evar.set', 'ExcellentCourses_evar', this.protrialDetail.title);
      }
    },
    // 获取推荐精品课列表
    async getProtrialRecommend() {
      const res = await reqProtrialRecommend(this.projectId);
      if (res?.code === 0) {
        this.porjectList = res?.data;
      }
    },
    async goPojectDetial(item) {
      // 校验是否登录
      if (!this.userInfo?.id) {
        // 区分App和h5
        if (this.$root.$data.isApp) {
          this.$sendToApp('login');
        } else if (this.$root.whatEev === 'miniprogram') {
          if (item.memberLevel && this.userInfo.level !== 30) {
            this.$refs.member.showPop = true;
            return;
          }
          // 精品专题课列表
          this.$router.push({
            path: '/projectDetail',
            query: {
              projectId: item.id,
            },
          });
        } else {
          // H5
          const { path, query } = this.$route;
          this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        }
      } else {
        if (item.memberLevel && this.userInfo.level !== 30) {
          this.$refs.member.showPop = true;
          return;
        }
        // 精品专题课列表
        this.$router.push({
          path: '/projectDetail',
          query: {
            projectId: item.id,
          },
        });
      }
    },
    // 学习次数累加
    async getStudyAccumulate(projectId) {
      await reqProtrialAccumulate(projectId);
    },
    // 跳转教师详情
    teacherDetail(item) {
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          { url: `${setBaseUrl('')}/ark/teacherDetail?teacherId=${item.id}` },
          false,
        );
        return;
      }
      this.$router.push({
        path: '/teacherDetail',
        query: { teacherId: item.id },
      });
    },
    verScroll() {
      // const width = this.protrialDetail?.videoInfos?.length * 180;
      const width = this.videoList?.length * 180 + 10;
      // 动态计算出滚动区域的大小，前面已经说过了，产生滚动的原因是滚动区域宽度大于父盒子宽度
      this.$refs.cont.style.width = `${width}px` || '360px'; // 修改滚动区域的宽度
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.wrapper, {
            startX: 0, // 配置的详细信息请参考better-scroll的官方文档，这里不再赘述
            click: true,
            tap: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: 'vertical',
            // bounce: false,
            bounceTime: '100',
            // probeType: 3,
          });
        } else {
          this.scroll.refresh(); // 如果dom结构发生改变调用该方法
        }
        // this.scroll.on('scroll', (e) => {
        //   // 触发时机：滚动过程中，具体时机取决于选项中的 probeType。
        //   console.log(e, '滚动中');
        // });
        // this.scroll.on('scrollEnd', (e) => {
        //   console.log(e, '滚动结束');
        // });
      });
    },
    // 批量教师查询
    async getTeacherList() {
      const idsList = this.protrialDetail.teacherIds || [];
      if (!idsList.length) return;
      const res = await reqTeacherList(idsList);
      if (res.code === 0 && res.data) {
        this.teacherListData = res.data;
        // eslint-disable-next-line no-unused-expressions
        this.teacherListData?.map((item) => {
          Object.assign(item, {
            teachMainModule: item.teachMainModule?.split(','),
          });
        });
      }
    },
    // 查询课程卡片信息
    async getCourseCardInfo() {
      const { productList } = this.protrialDetail;
      // type 3 课程 4 套餐
      const allProductIds = [];
      const allPackageIds = [];

      productList.forEach((item) => {
        if (item.type === 3) {
          allProductIds.push(item.businessId);
        } else if (item.type === 4) {
          allPackageIds.push(item.businessId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = resetProductData(res?.data || []);
        const resPackage = resetCoursePackage(res1?.data || []);
        const allCoursePre = [...resCourse, ...resPackage];
        const allCourseNext = [];
        // 按照接口数据的顺序排序
        productList.forEach((item) => {
          const fillterItem = allCoursePre.filter((e) => {
            const id = e?.productId || e?.packageId || null;
            return id === item.businessId;
          });
          if (fillterItem.length) {
            allCourseNext.push(fillterItem[0]);
          }
        });
        this.courseInfoData = allCourseNext;
      });
    },

    async init() {
      this.loading = true;
      try {
        this.videoList = this.protrialDetail?.videoInfos;
        if (!this.videoList) {
          this.loading = false;
          return;
        }
        this.idx = 0;
        this.initData();
      } catch (e) {
        if (String(e).indexOf('Network Error') > -1) {
          this.$toast('无可用网络，请检查您的网络');
        } else {
          this.$toast('未查询到视频');
        }
      }
    },
    // 获取视频时长
    getVideoMinTime(time) {
      if (!time) return 0;
      if (time < 60) return `${time}s`;
      const mins = Math.floor(time / 60);
      return `${mins}min`;
    },
    // 重新播放
    replay() {
      this.activeId = 0;
      this.idx = 0;
      this.player.changeVideo(this.videoList[0].vid, {});
      this.scroll.scrollTo(0, 0);
      this.lastPaly = false;
    },
    initData() {
      document.getElementById('player').innerHTML = '';
      loadJS([
        {
          async: false,
          url: 'https://p.bokecc.com/player?siteid=096E928BC2A97B87&newversion=true',
        },
      ]).then(() => {
        this.setPlayerCallBack();
      });
    },

    createPlayer() {
      this.playerEle = document.getElementById('player');

      this.idx %= this.videoList.length;
      const { idx, videoList } = this;

      const videoItem = videoList[idx];
      const verfitionCode = {
        type: 1,
        videoId: videoItem.id,
      };
      if (videoItem && videoItem.vid) {
        this.player = window.createCCH5Player({
          vid: videoItem.vid,
          siteid: RECORD_SITE_ID,
          playtype: 1,
          autoStart: true,
          realAutoPlay: true,
          width: '100%',
          height: '100%',
          open_barrage: false,
          parentNode: this.playerEle,
          isShare: false, // TODO：隐藏分享按钮，目前现在不生效，用CSS强制隐藏了
          vc: JSON.stringify(verfitionCode),
        });
        this.gioEvent(videoItem);
      } else {
        this.$toast('视频地址出错,请稍后重试～');
      }
    },
    nextPlayer() {
      if (this.idx >= this.videoList.length) {
        this.idx = 0;
      } else {
        this.idx += 1;
        this.activeId += 1;
        this.player.changeVideo(this.nextVideoInfo.vid, {});
        if (this.activeId > 1) {
          const num = this.activeId - 1;
          const leftX = -180 * num;
          this.scroll.scrollTo(leftX, 0);
        }
      }
      this.videoEndTool = false;
    },

    setPlayerCallBack() {
      if (window.createCCH5Player) {
        this.createPlayer();
      } else {
        window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      }
      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      window.on_CCH5player_ready = this.onPlayerReady;
      window.on_player_volumechange = this.onPlayerVolumeChange;
      window.on_CCH5player_ended = this.onPlayerEnded;
      window.on_CCH5player_play = this.onPlayerPlay;
      window.on_CCH5player_pause = this.onPlayerPause;
      // window.get_cc_verification_code = this.get_cc_verification_code;
    },

    onCCH5PlayerLoaded() {
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },

    onPlayerReady() {
      this.loading = false;
      window.cc_js_Player.setVolume(0.3);
      this.player.play();
    },
    // 播放结束时回调
    onPlayerEnded() {
      if (this.idx < this.videoList.length - 1) {
        this.nextVideoInfo = this.videoList[this.idx + 1];
        // 播放下一个
        this.nextPlayer();
        this.gioEvent(this.nextVideoInfo);
      } else {
        // 播放完
        if (this.idx === this.videoList.length - 1) {
          this.lastPaly = true;
        }
        this.nextVideoInfo = {};
      }
      this.videoEndTool = true;
    },

    // 播放时回调
    onPlayerPlay() {
      this.videoEndTool = false;
    },
    // 暂停播放是回调
    onPlayerPause() {
      // 回调
    },
    onPlayerVolumeChange() {
      // console.log('设置音量回调:  ', volume, vid);
    },
    scrollInit() {
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
    },
    async gioEvent(data) {
      const { name: videoName, vid } = data;
      const { title, id: projectId } = this.protrialDetail;
      let res = await reqClassNameType(projectId);
      // eslint-disable-next-line no-undef
      gio('track', 'listenCourse_event', {
        videoID_var: vid,
        videoName_var: videoName,
        videoType_var: '录播',
        isAudition_var: '是',
        courseId_var: projectId.toString(),
        courseName_var: title,
        classSize_var: res.data.className,
        platform_var: gioPlatform(),
        enter_var: '精品专题课',
      });
    },
  },
  destroyed() {
    // eslint-disable-next-line no-unused-expressions
    this.player && this.player.destroy();
  },
  mounted() {
    this.scrollInit();
    this.getProtrialDetail();
    // 学习次数累加
    this.getStudyAccumulate(this.$route.query.projectId);
  },
};
</script>

<style scoped lang="scss">
.projectDetailPage {
  width: 100%;
  padding-bottom: 150px;
  overflow: hidden;
  background: #f7f8fc;

  .empty {
    width: 100%;
    height: 100px;
  }

  .video-player {
    position: relative;

    #player,
    #playbackPlayer {
      display: flex;
      align-items: center;
      height: calc(100vw * (9 / 16));
      background: black;
    }

    .next-video {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: white;
      background: rgba(0, 0, 0, 0.5);

      .video-title {
        padding: 0 20%;
      }

      span {
        margin-bottom: 20px;
        font-size: 26px;
      }

      .tool-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 22px;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .replay-btn {
          width: 150px;
          height: 50px;
          color: #ff6c02;
          font-size: 26px;
          border: 2px solid #ff6c02;
          border-radius: 23px;
        }

        div:last-child {
          width: 150px;
          height: 50px;
          color: white;
          font-size: 26px;
          background: #ff6c02;
          border: 2px solid #ff6c02;
          border-radius: 23px;
        }

        .next-btn {
          margin-left: 24px;
        }
      }
    }
  }

  .projectHeaderBox {
    width: 100%;

    h3 {
      padding: 36px 36px 22px 36px;
      color: #000;
      font-weight: 400;
      font-size: 25px;
      line-height: 45px;
      background: #fff;
    }

    .courseTotalNum {
      width: 100%;
      margin: 0 auto;
      padding-left: 36px;
      color: #666;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
      background: #fff;
    }

    .projectVideoList {
      box-sizing: border-box;
      width: 100%;
      margin-bottom: 22px;
      padding: 14px 0 29px 0;
      background: #fff;

      .projectScrollBox {
        display: flex;
        padding-left: 29px;

        li {
          .centerVideo {
            position: relative;
            width: 303px;
            height: 172px;
            margin-right: 18px;
            background: pink;
            border-radius: 14px;

            img {
              width: 303px;
              height: 172px;
              border-radius: 14px;
            }

            .activeVideo {
              background: rgba(0, 0, 0, 0.7) !important;
            }

            .infoVideo {
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              width: 303px;
              height: 172px;
              text-align: center;
              background: rgba(0, 0, 0, 0.3);
              border-radius: 14px;

              > div {
                position: absolute;
                top: 7px;
                right: 7px;
                width: 36px;
                height: 36px;
                color: #fff;
                font-weight: 400;
                font-size: 18px;
                line-height: 36px;
                background: linear-gradient(49deg, #ff722e 0%, #ff9571 100%);
                border-radius: 7px;
              }

              > span {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 76px;
                color: #fff;
                font-weight: 500;
                font-size: 18px;
                line-height: 25px;
              }

              > p {
                position: absolute;
                right: 20px;
                bottom: 18px;
                color: #fff;
                font-weight: 500;
                font-size: 18px;
                line-height: 25px;
              }
            }
          }

          .centerVideoName {
            width: 303px;
            margin-top: 14px;
            color: #333;
            font-weight: 400;
            font-size: 25px;
            line-height: 36px;
          }
        }
      }
    }

    .teacherInfo {
      box-sizing: border-box;
      width: 100%;
      padding-bottom: 36px;
      background: #fff;

      .teacherList {
        .teacherItem {
          display: flex;
          width: 100%;
          padding: 0 36px;

          img {
            width: 190px;
            height: 254px;
            margin-right: 28px;
            background: linear-gradient(180deg, #c0daf4 0%, #f1f8ff 100%);
            border-radius: 14px;
          }

          .introduceTeacher {
            width: 458px;

            > h5 {
              margin-top: 13px;
              color: #333;
              font-weight: 500;
              font-size: 29px;
              line-height: 40px;
            }

            ul {
              display: flex;
              flex-wrap: wrap;
              margin: 14px 0 22px 0;

              li {
                margin-right: 10px;
                margin-bottom: 6px;
                padding: 2px 7px;
                color: #fe9766;
                font-weight: 400;
                font-size: 22px;
                line-height: 31px;
                background: #fef5f1;
                border-radius: 7px;
              }
            }

            p {
              color: #333;
              font-weight: 400;
              font-size: 25px;
              line-height: 40px;
            }

            .ellipsis-3 {
              display: inline-block;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;

              /* autoprefixer: off */
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            }
          }
        }
      }
    }

    .subPartTitle {
      margin-bottom: 29px;
      padding-top: 29px;
      padding-left: 36px;
      color: #111;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }

    .courseRecommend {
      position: relative;
      width: 100%;
      min-height: 556px;
      margin-top: 22px;
      padding: 36px 36px 18px 36px;
      background: linear-gradient(360deg, #fff 0%, #fcede6 100%);

      .bg {
        position: absolute;
        top: 0;
        right: 0;
        width: 678px;
        height: 190px;
      }

      .subIntroduce {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 678px;
        height: 91px;
        margin: 0 auto;
        padding: 14px 36px;
        background: #ff7f41;
        border-radius: 14px;

        img {
          width: 36px;
          height: 36px;
          margin-right: 22px;
        }

        span {
          color: #fff;
          font-weight: 400;
          font-size: 22px;
          line-height: 31px;
        }
      }

      .courseBox {
        margin-top: 125px;
      }
    }

    .projectPart {
      width: 100%;
      margin-top: 22px;
      padding: 0 36px;
      background: #fff;

      .projectBox {
        display: flex;
        justify-content: space-between;
      }

      .subPartTitle {
        padding-left: 0;
      }
    }
  }
}

.audition-page {
  .video-list {
    max-height: calc(100vh - 100vw * (9 / 16) - 100px - 100px);
    padding-bottom: 200px;
    overflow-y: scroll;

    .videolistBox {
      display: flex;
      align-items: flex-end;
      padding: 36px;
      border-bottom: 2px solid #f5f5f5;

      .title {
        width: 90%;
        font-size: 25px;
        line-height: 28px;
      }

      .videoDurUi {
        color: #333;
        font-size: 14px;
      }
    }

    .title-active {
      color: $theme_color;
    }
  }
}

::v-deep .common-foot {
  position: fixed;
  right: 0;
  left: 0;
}

::v-deep #ccH5historyTimeBox {
  display: none !important;
}
</style>
<style lang="scss">
.audition-page {
  .adrPlayBtn {
    display: none !important;
  }
}
</style>
